<template>
  <InlineSvg
    :id="id"
    :src="src"
    :width="imgWidth ? imgWidth+'px':null"
    :transform-source="transform"
    @loaded="svgLoaded($event)"
    @mouseover="hover = true"
    @mouseleave="hover = false"
    @click="click"
    :class="svgClass"
  ></InlineSvg>
</template>

<script>
import InlineSvg from "vue-inline-svg";
export default {
  name: "BaseInlineSvg",
  ////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////
  components: {
    InlineSvg,
  },
  /////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////
  props: {
    id: [String, Number],
    isGradient: {
      type: Boolean,
      default: false,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
    src: {
      type: String,
      required: true,
    },
    classState: {
      type: Array
    },
    interactiveMethods: {
      type: Array
    },
    imgWidth: {
      type: Number,
      default: 0
    },
    svgClass: String,
    eventClick: {
      type: Boolean,
      default: true
    }
  },
  ////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////
  data() {
    return {
      hover: false,
      target:null,
      selected:null
    };
  },
  ////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////
  methods: {
    transform(el) {
      let svg = el;

      // If "transform" method function exist (perhaps for specific modification)
      if (typeof this.$parent.transform == "function") {
        svg = this.$parent.transform(el, this.hover);
      }

      // Check if defs element exist into svg
      let defsExist = false;
      let defs = svg.querySelector("defs");
      if ((this.isGradient || this.isActive) && !defs) {
        defs = document.createElementNS("http://www.w3.org/2000/svg", "defs");
      } else {
        defsExist = true;
      }

      if (this.isGradient) {
        // ******** DEFAULT ********** */
        if (!svg.getElementById("gradientDefault")) {
          let init = document.createElement("linearGradient");
          init.setAttribute("id", "gradientDefault");
          init.setAttribute("x2", 0);
          init.setAttribute("y2", 1);

          let defautStop1 = document.createElement("stop");
          defautStop1.setAttribute("offset", "0%");
          defautStop1.setAttribute("class", "defaultStart");

          let defautStop2 = document.createElement("stop");
          defautStop2.setAttribute("offset", "80%");
          defautStop2.setAttribute("class", "defaultStop");
          init.append(defautStop1);
          init.append(defautStop2);
          defs.append(init);
        }

        //********* HOVER *********** */
        if (!svg.getElementById("gradientHover")) {
          let gradient = document.createElement("linearGradient");
          gradient.setAttribute("id", "gradientHover");
          gradient.setAttribute("x2", 0);
          gradient.setAttribute("y2", 1);

          let stop1 = document.createElement("stop");
          stop1.setAttribute("offset", "0%");
          stop1.setAttribute("class", "hoverStart");

          let stop2 = document.createElement("stop");
          stop2.setAttribute("offset", "80%");
          stop2.setAttribute("class", "hoverStop");
          gradient.append(stop1);
          gradient.append(stop2);
          defs.append(gradient);
        }
        /************ ACTIVE ********* */
        if (this.isActive && !svg.getElementById("gradientActive")) {
          let active = document.createElement("linearGradient");
          active.setAttribute("id", "gradientActive");
          active.setAttribute("x2", 0);
          active.setAttribute("y2", 1);

          let stop1 = document.createElement("stop");
          stop1.setAttribute("offset", "0%");
          stop1.setAttribute("class", "activeStart");

          let stop2 = document.createElement("stop");
          stop2.setAttribute("offset", "80%");
          stop2.setAttribute("class", "activeStop");

          active.append(stop1);
          active.append(stop2);

          // Add element to defs
          defs.append(active);
        }

        // Add defs to svg if not exist
        if (!defsExist) svg.appendChild(defs);
      }

      //Add default class "illustration" on path with class done
      //To work with css
      if (this.classState && this.classState.length > 0) {
        for (let i = 0; i < this.classState.length; i++) {
          let el = svg.getElementsByClassName(this.classState[i].class);
          if (el.length > 0) {
            for (let r = 0; r < el.length; r++) {
              //el[r].setAttribute('id', this.classState[i].class);
              el[r].classList.add("illustration");

              //To give initial state on construction ?
              //if(this.classState[i].state) el[r].classList.add(this.classState[i].state);
            }
          }
        }
      }

      

      return svg;
    },

    svgLoaded(svg) {
        if (this.interactiveMethods && this.interactiveMethods.length > 0) {
        
        let thisCurrent = this;
        let elOver = svg.getElementsByClassName("over");
        if (elOver && elOver.length > 0) {
          for (let el of elOver) {
            if (this.interactiveMethods.includes("onOver")) {
              el.addEventListener("mouseover", function(){
                let target = el.getAttribute('data-id');
                thisCurrent.target = target;
                let sel = svg.getElementsByClassName(target);
                sel[0].classList.add("active");
              });
            }
            if (this.interactiveMethods.includes("onOut")) {
               el.addEventListener("mouseleave", function(){
                thisCurrent.target = null;
                let list = svg.getElementsByClassName("illustration");
                for (let path of list) { path.classList.remove("active"); }
              });
            }
            if (this.interactiveMethods.includes("onClick")) {
               el.addEventListener("click", function(){
                thisCurrent.selected = el.getAttribute('data-id');
              });
            }
          }
        }
        
      }
    },

    click(){
      if (this.eventClick)
        this.$emit('click', this.isActive)
    }

  },
  ////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////
  watch: {
      //If target change, pass to parent
      target: function (val) {
        this.$emit('emitOver',val)
      },
      //If selected change, pass to parent
      selected: function (val) {
        this.$emit('emitSelected',val)
      },
  },
};
</script>
